<template>
    <div class="price-outdate">
        <div class="container">
            <div class="main_blck">
                <div class="img  p-center">
                    <img src="../../../img/01-clock.svg" alt="">
                </div>
                <div class="text  p-center">
                   <p class="p-title relawayBold p-black">Sorry, price outdated...</p>
                    <p class="Raleway p-center min-med">You need to update the search result to proceed</p>
                    <button class="btn btn-green">Update search results</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PriceOutdate"
    }
</script>
